@if (
  (length > 0 || options?.footer?.onlyShowIfPaginated) &&
  options?.paging.enabled
) {
  <footer class="Footer">
    @if (
      options?.footer?.isLabelPresent ? options.footer?.isLabelPresent : true
    ) {
      <section class="Footer__count">
        @if (length > options?.paging?.pageSize) {
          <p class="t-data t-alt" tabindex="0">
            Showing
            {{
              getRangeLabel(
                options?.paging?.pageIndex,
                options?.paging?.pageSize,
                length
              )
            }}
            of {{ length }} {{ options?.paging?.pageName }}
          </p>
        } @else {
          <p class="t-data t-alt" tabindex="0">
            Showing 1 - {{ length }} of {{ length }}
            {{ options?.paging?.pageName }}
          </p>
        }
      </section>
    }
    @if (length > options.paging.pageSize) {
      <section class="Footer__pagination">
        @if (options.footer.showFirstLastPageDoubleArrows) {
          <div>
            <button
              class="Footer__pagination--button"
              type="button"
              [disabled]="!hasPreviousPage()"
              (click)="firstPage()"
              [attr.aria-label]="'Go to first page'"
              tabindex="0"
            >
              <icon name="first_page" [config]="options.footer"></icon>
            </button>
          </div>
        }
        @if (options.footer.showSinglePagePaginationButtons) {
          <div>
            <button
              class="Footer__pagination--button"
              [disabled]="!hasPreviousPage()"
              type="button"
              (click)="previousPage()"
              [attr.aria-label]="'Go to previous page'"
              tabindex="0"
            >
              <icon name="chevron_left" [config]="options.footer"></icon>
            </button>
          </div>
        }
        <button
          class="Footer__pagination--button"
          type="button"
          tabindex="0"
          aria-label="currentPage"
        >
          @if (!options.footer.showCurrentPageNumberOnly) {
            <p class="t-data t-bold">
              {{ currentPage }} / {{ getNumberOfPages() }}
            </p>
          }
          @if (options.footer.showCurrentPageNumberOnly) {
            <p class="t-data t-bold">
              {{ currentPage }}
            </p>
          }
        </button>
        @if (options.footer.showSinglePagePaginationButtons) {
          <div>
            <button
              class="Footer__pagination--button"
              type="button"
              [disabled]="!hasNextPage()"
              (click)="nextPage()"
              [attr.aria-label]="'Go to next page'"
              tabindex="0"
            >
              <icon name="chevron_right" [config]="options.footer"></icon>
            </button>
          </div>
        }
        @if (options.footer.showFirstLastPageDoubleArrows) {
          <div>
            <button
              class="Footer__pagination--button"
              type="button"
              [disabled]="!hasNextPage()"
              (click)="lastPage()"
              [attr.aria-label]="'Go to last page'"
              tabindex="0"
            >
              <icon name="last_page" [config]="options.footer"></icon>
            </button>
          </div>
        }
      </section>
    }
  </footer>
}
